/* eslint-disable no-unused-vars */
import { keycloak } from '../utils/keycloak'

export default ( {
	keycloak,
	user: false,
	userRoles: false,
	language: 'sl' // navigator.language.split( /[-_]/ )[ 0 ]	// TODO we need only for EN and SL
} )
